<main-app-header></main-app-header>
<div class="thankyou-bg privacy-policy-bg">
    <div class="logo">
    </div>
    <div class="thankyou-box box-shadow privacy-policy-box">
        <div class="grid-tiles-main" style="padding:0px !important;">
            <div class="grid-tile-benefits">
              <h5 class="section" style="margin-top:10px;">PRODUCT FEATURES</h5>
              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">The first
                communications quantum resistant encryption — QRE™
              </p>
              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">Fully
                integrated package:</p>
                <p class="bullet"> Messaging</p>
                <p class="bullet"> Voice</p>
                <p class="bullet"> Video</p>
                <p class="bullet"> Conferencing</p>

      

              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">Hosted in
                a secure data center in the U.S.A.</p>
              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">
                Independent of big tech.</p>
              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">No
                communications stored on our servers.</p>
              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">
                Disappearing messages set by sender.</p>
              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">
                Subscriptions with simple, intelligent pricing.</p>

            </div>
            <div class="grid-tile-benefits">
              <h5 class="section" style="margin-top:10px;">BENEFITS</h5>
              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">All your
                communications are protected today against future threats from next generation quantum computing.</p>
              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">One
                end-to-end encrypted platform for all communications on <strong>iOS, Android, iMac, Windows, Linux</strong></p>
          
              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">Not
                subject to the policies and practices of jurisdictions of other countries.</p>
              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">No risk
                of being shut down.</p>
              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">Complete
                privacy and confidentiality. Zero risk content may be hacked or leaked.</p>
              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">Sender
                controls if and when messages expire on recipient’s devices for ultimate privacy.
              </p>
              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">We do not
                sell your information as some free apps may.</p>
              <p class="main-bullets text-start" data-aos-anchor-placement="bottom-bottom">We
                collect no information about users except log-in credentials and payment method. Clean and functional
                user experience.</p>

            </div>
          </div>       

    </div>
</div>